import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import Icon from '../Icon'

import { ActionIconBackground, ActionIconPosition } from './types'

export const Container = styled(Link)<{ $iconPosition?: ActionIconPosition }>`
  --transition-duration: 0.3s;
  --border-color: rgba(0, 0, 0, 0.3);
  --flex-orientation: ${({ $iconPosition }) =>
    $iconPosition === ActionIconPosition.left ? 'row-reverse' : 'row'};
  display: flex;
  flex-flow: var(--flex-orientation, row) nowrap;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border: 1px solid var(--border-color);
  text-align: left;
  color: ${({ theme }) => theme.colors.black};
  transition: border-color var(--transition-duration)
    cubic-bezier(0.76, 0, 0.24, 1);
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:not(:disabled):active,
  &:not(:disabled):focus,
  &:not(:disabled):hover {
    --border-color: rgba(0, 0, 0, 1);
  }
`

export const Label = styled.span`
  ${({ theme }) => theme.textStyles.d1440_button}
  flex: 1 1 0;
  display: flex;
  align-items: center;
  min-height: ${pxToRem(42)};
  padding-inline: ${pxToRem(24)};
  padding-block: ${pxToRem(14)} ${pxToRem(12)};
  @media ${mq(sizes.tablet)} {
  }
`
type DecorationProps = {
  $color?: string
  $position?: ActionIconPosition
  $background?: ActionIconBackground
}
export const Decoration = styled.span<DecorationProps>`
  --size: ${pxToRem(32)};
  --inset-offset__arrow: ${pxToRem(6)};
  --inset__before: ${({ $position }) =>
    $position === ActionIconPosition.left ? '0 0 0 auto' : '0 auto 0 0'};
  --color__arrow: ${({ $color, $background, theme }) =>
    $background === ActionIconBackground.color
      ? theme.colors.black
      : $color
        ? $color
        : theme.colors.white};
  --background__decoration: ${({ $background, $color, theme }) =>
    $background === ActionIconBackground.color ? $color : theme.colors.black};
  position: relative;
  align-self: flex-start;
  width: 0;
  height: var(--size);
  transition: width var(--transition-duration) cubic-bezier(0.76, 0, 0.24, 1);
  overflow: hidden;
  background-color: var(--background__decoration);
  &::before,
  &::after {
    content: '';
    position: absolute;
    background-color: var(--border-color);
    transition: background-color var(--transition-duration)
      cubic-bezier(0.76, 0, 0.24, 1);
  }
  &::before {
    inset: var(--inset__before);
    width: 1px;
  }
  &::after {
    inset: auto 0 0 0;
    height: 1px;
  }
  ${Container}:not(:disabled):focus &,
  ${Container}:not(:disabled):active &,
  ${Container}:not(:disabled):hover & {
    width: var(--size);
    &::before,
    &::after {
      opacity: 1;
      transition: background-color var(--transition-duration)
        cubic-bezier(0.76, 0, 0.24, 1);
    }
  }
`
export const Arrow = styled(Icon)`
  color: var(--color__arrow);
  position: absolute;
  /* inset: var(--inset) auto auto var(--inset); // the arrow is revealead without moving */
  inset: var(--inset-offset__arrow) var(--inset-offset__arrow) auto auto; // the arrow moves from "behind the label"
  width: calc(var(--size) - var(--inset-offset__arrow) * 2);
  height: calc(var(--size) - var(--inset-offset__arrow) * 2);
`
